import axios from "axios";
import { wsService } from "../wsService";

const api_url = process.env.VUE_APP_API_URL;
const section = "shippings";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function listAllShipping(param = { enable: true }) {
  return wsService.make_post_request(section + "/listAllShipping", param);
}

function listShippingVisits(param = { enable: true }) {
  return wsService.make_post_request(section + "/visits", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function pregeo(param = {}) {
  return wsService.make_post_request(section + "/pregeo", param);
}

function states() {
  return wsService.make_get_request(section + "/states");
}

function print(code) {
  const url = `${section}/print/label/${code}/termica`;

  const token = localStorage.getItem("token");

  return axios.get(api_url + url, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/pdf",
      Authorization: "Bearer " + token,
    },
  })
  .then((response) => {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank"); // 🔥 Abre directamente el PDF en una nueva pestaña
  })
  .catch((error) => {
    console.error("Network Error:", error);
    const msg =
      error?.response?.data?.msg ||
      error?.message ||
      "Ocurrió un error al imprimir";
    this.$toast?.error?.(msg, "Error");
  });
}

export const shippingService = {
  section,
  filter,
  remove,
  create,
  update,
  pregeo,
  states,
  listAllShipping,
  listShippingVisits,
  print
};
